import React from 'react';

export interface IconArrowLeftProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconArrowLeft: React.FC<IconArrowLeftProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path fillRule="evenodd" clipRule="evenodd" d="M11.0303 5.78032L11.5607 5.24999L10.5 4.18933L9.96968 4.71966L3.21968 11.4697L2.68935 12L3.21968 12.5303L9.96968 19.2803L10.5 19.8107L11.5607 18.75L11.0303 18.2197L5.56067 12.75H20.25H21V11.25H20.25H5.56067L11.0303 5.78032Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconArrowLeft;
